module.exports = __webpack_public_path__ + "static/media/img2.86e3ca33.jpg";